export default {

    Banks: 'Bank|Banks',
};
